/* Sop. Essential · Configurador Kit AM6 · parte 2 de 4: eventos y pasos (requiere sop-kit.js) */
(function () {
  'use strict';
  var S = window.SopKit, Kit = S.Kit, MAX_PHOTO = S.MAX_PHOTO, STEPS = S.STEPS, hslHex = S.hslHex, fmt = S.fmt;

  Kit.prototype.setSlot = function (slot, val) {
    if (slot === 'pinon') { this.state.plogo = val; this.after('pinon'); return; }
    this.state[slot] = val;
    var input = this.$('[data-text="' + slot + '"]');
    if (input && (!val || val.type !== 'text')) input.value = '';
    this.after(slot);
  };

  Kit.prototype.bind = function () {
    var self = this, st = this.state;
    var form = this.$('[data-sk-form]');

    form.addEventListener('change', function (e) {
      var t = e.target, m;
      if (t.name === 'sk-design') { st.design = t.value; self.after('design'); }
      else if (t.name === 'sk-pmodel') { st.pmodel = t.value; self.after('pmodel'); }
      else if (t.name === 'sk-ptype') {
        st.ptype = t.value;
        self.after('pinon');
        var inp = self.$('[data-ptext="' + t.value + '"]');
        if (inp) inp.focus();
      } else if ((m = /^sk-(base|det|let)$/.exec(t.name))) {
        var key = m[1], prev = st[key];
        if (t.value === '__other') {
          if (!prev || !prev.custom) {
            var c = { custom: true, h: 210, s: 80, l: 45, ref: '', name: 'Personalizado' };
            c.hex = hslHex(c.h, c.s, c.l);
            st[key] = c;
          }
        } else {
          st[key] = { name: t.value, hex: t.dataset.hex, custom: false };
        }
        self.after(key);
      } else if (t.dataset.opt != null) {
        st.opts[+t.dataset.opt] = t.value;
        self.after('opts');
      } else if (t.name === 'sk-igon') { st.igOn = t.value; self.after('igOn'); }
      else if (t.matches('[data-ig-same]')) { st.igSame = t.checked; self.after('ig'); }
      else if (t.matches('[data-photo]')) {
        var f = t.files && t.files[0];
        var tooBig = f && f.size > MAX_PHOTO;
        self.photo = f && !tooBig ? f : null;
        if (tooBig) t.value = '';
        self.$('[data-err="photo"]').hidden = !tooBig;
        self.render();
      }
    });

    form.addEventListener('input', function (e) {
      var t = e.target, picker;
      if (t.dataset.ptext === 'num') {
        t.value = t.value.replace(/\D/g, '');
        st.pnum = t.value; self.after('pinon');
      } else if (t.dataset.ptext === 'text') {
        st.ptext = t.value; self.after('pinon');
      } else if (t.dataset.pk && (picker = t.closest('[data-picker]'))) {
        var c = st[picker.dataset.picker];
        if (!c || !c.custom) return;
        c[t.dataset.pk] = +t.value;
        c.hex = hslHex(c.h, c.s, c.l);
        self.after(picker.dataset.picker);
      } else if (t.matches('[data-pk-ref]') && (picker = t.closest('[data-picker]'))) {
        var cc = st[picker.dataset.picker];
        if (cc && cc.custom) { cc.ref = t.value; self.after(picker.dataset.picker); }
      } else if (t.dataset.text) {
        self.setSlot(t.dataset.text, t.value.trim() ? { type: 'text', value: t.value } : null);
      } else if (t.matches('[data-ig-tapa]') || t.matches('[data-ig]')) {
        if (t.value.charAt(0) === '@') t.value = t.value.replace(/^@+/, '');
        if (t.matches('[data-ig-tapa]')) { st.igTapa = t.value; self.after('igTapa'); }
        else { st.ig = t.value; self.after('ig'); }
      } else if (t.matches('[data-notes]')) {
        st.notes = t.value;
        self.save();
      }
    });

    // En móvil, con el teclado abierto la vista previa deja de ser fija
    form.addEventListener('focusin', function (e) {
      if (e.target.matches('input[type="text"], input:not([type]), textarea')) self.root.classList.add('is-typing');
    });
    form.addEventListener('focusout', function () {
      setTimeout(function () {
        if (!self.root.contains(document.activeElement) || !document.activeElement.matches('input[type="text"], textarea')) {
          self.root.classList.remove('is-typing');
        }
      }, 120);
    });

    this.$$('[data-pick]').forEach(function (b) {
      b.addEventListener('click', function () { self.openLogos(b.dataset.pick); });
    });
    this.$$('[data-clear]').forEach(function (b) {
      b.addEventListener('click', function () { self.setSlot(b.dataset.clear, null); });
    });
    this.$$('[data-goto]').forEach(function (b) {
      b.addEventListener('click', function () { self.showStep(+b.dataset.goto, true); });
    });
    this.$('[data-sk-next]').addEventListener('click', function () { self.next(); });
    this.$('[data-sk-prev]').addEventListener('click', function () { self.showStep(self.step - 1, true); });
    var share = this.$('[data-sk-share]');
    if (share) share.addEventListener('click', function () { self.share(); });

    // Añadido rápido. Estados: off → (cfg: los personalizables piden cómo lo quieres) → on (va con el kit).
    // No se marca como añadido hasta confirmar; entra al carrito junto con el kit.
    this.$$('[data-up]').forEach(function (li) {
      var btn = li.querySelector('[data-up-toggle]');
      var sel = li.querySelector('[data-up-variant]');
      var note = li.querySelector('[data-up-note]');
      var cfg = li.querySelector('[data-up-cfg]');
      var doneEl = li.querySelector('[data-up-done]');
      var priceEl = li.querySelector('[data-up-price]');
      var state = 'off';
      function price() {
        var o = sel.tagName === 'SELECT' ? sel.options[sel.selectedIndex] : sel;
        return +o.dataset.price;
      }
      function set(s) {
        state = s;
        li.classList.toggle('is-on', s === 'on');
        li.classList.toggle('is-cfg', s === 'cfg');
        btn.hidden = s === 'cfg';
        btn.setAttribute('aria-pressed', s === 'on' ? 'true' : 'false');
        btn.textContent = s === 'on' ? 'Quitar' : 'Añadir';
        if (cfg) cfg.hidden = s !== 'cfg';
        if (doneEl) {
          doneEl.hidden = s !== 'on';
          var n = note && note.value.trim();
          doneEl.innerHTML = '<b>Va con tu kit</b>' + (n ? ' · ' + S.esc(n) : '') + (cfg ? ' <button type="button" class="sk-link" data-up-edit>Cambiar</button>' : '');
        }
        self.render();
      }
      if (sel.tagName === 'SELECT') {
        sel.addEventListener('change', function () { priceEl.textContent = fmt(price()); self.render(); });
      }
      btn.addEventListener('click', function () {
        if (state === 'on') set('off');
        else if (cfg) { set('cfg'); self.reveal(cfg); }
        else set('on');
      });
      li.addEventListener('click', function (e) {
        if (e.target.closest('[data-up-ok]')) set('on');
        else if (e.target.closest('[data-up-cancel]')) set('off');
        else if (e.target.closest('[data-up-edit]')) { set('cfg'); self.reveal(cfg); }
      });
      if (note) note.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); set('on'); } });
      li._skExtra = function () {
        if (state !== 'on') return null;
        return { id: +sel.value, price: price(), note: note ? note.value.trim() : '' };
      };
    });

    // Hoja de logos
    var sheet = this.$('[data-sk-logos]');
    sheet.querySelector('[data-sheet-close]').addEventListener('click', function () { sheet.close(); });
    sheet.addEventListener('click', function (e) { if (e.target === sheet) sheet.close(); });
    sheet.querySelector('[data-sheet-search]').addEventListener('input', function (e) {
      var q = e.target.value.trim().toLowerCase();
      Array.prototype.forEach.call(sheet.querySelectorAll('[data-logo]'), function (b) {
        b.hidden = q && b.dataset.logo.toLowerCase().indexOf(q) === -1;
      });
    });
    function done() { sheet.close(); }
    // Tocar un logo lo pone en la vista previa al momento; la hoja sigue abierta para probar otros
    sheet.querySelector('[data-sheet-grid]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-logo]');
      if (!b || !self.pickSlot) return;
      self.setSlot(self.pickSlot, { type: 'logo', value: b.dataset.logo });
      Array.prototype.forEach.call(sheet.querySelectorAll('[data-logo]'), function (x) {
        x.classList.toggle('is-on', x === b);
        x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
      });
    });
    sheet.addEventListener('close', function () {
      var pick = self.pickSlot && self.$('[data-pick="' + self.pickSlot + '"]');
      if (pick) pick.focus({ preventScroll: true });
    });
    var reqInput = sheet.querySelector('[data-req-input]');
    function useReq() {
      var v = reqInput.value.trim();
      if (!v) { reqInput.focus(); return; }
      self.setSlot(self.pickSlot, { type: 'req', value: v });
      done();
    }
    sheet.querySelector('[data-req-use]').addEventListener('click', useReq);
    reqInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); useReq(); } });
  };

  // Deja un bloque a la vista entre la vista previa fija (arriba) y la barra de compra (abajo), sin abrir el teclado
  Kit.prototype.reveal = function (el) {
    var stage = this.$('.sk-stage'), bar = this.$('.sk-bar'), r = el.getBoundingClientRect();
    var top = stage && getComputedStyle(stage).position === 'sticky' ? stage.offsetHeight + 8 : 8;
    var bottom = window.innerHeight - (bar && getComputedStyle(bar).position === 'fixed' ? bar.offsetHeight : 0) - 12;
    var dy = r.bottom > bottom ? r.bottom - bottom : 0;
    if (r.top - dy < top) dy = r.top - top;
    if (dy) window.scrollBy({ top: dy, behavior: 'smooth' });
  };

  // Tras cualquier cambio: guardar, quitar el error si ya está bien, repintar
  Kit.prototype.after = function (key) {
    this.save();
    var miss = this.missing();
    var self = this;
    Object.keys(this.tried).forEach(function (k) {
      if (self.tried[k] && !miss.some(function (m) { return m.key === k; })) self.showErr(k, false);
    });
    this.render();
  };

  Kit.prototype.showErr = function (key, on) {
    var el = this.$('[data-err="' + key + '"]');
    if (el) el.hidden = !on;
    var box = el && el.closest('.sk-group, .sk-slot');
    if (box) box.classList.toggle('is-error', on);
    this.tried[key] = on;
  };

  Kit.prototype.showStep = function (n, focus) {
    n = Math.max(1, Math.min(STEPS, n));
    this.step = n;
    this.$$('[data-step]').forEach(function (p) { p.hidden = +p.dataset.step !== n; });
    if (n === 4 || (n === 2 && this.state.ptype === 'logo')) this.ensureLogoData();
    if (focus) {
      var flow = this.$('.sk-flow');
      // En móvil la vista previa va fija arriba: el paso empieza justo debajo de ella
      var top = flow.getBoundingClientRect().top, stage = this.$('.sk-stage');
      var off = stage && getComputedStyle(stage).position === 'sticky' && window.innerWidth < 990 ? stage.getBoundingClientRect().height + 8 : 24;
      if (top < off || top > window.innerHeight * 0.6) {
        var y = window.scrollY + top - off;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      }
      var legend = this.$('[data-step="' + n + '"] .sk-panel__title');
      if (legend) legend.focus({ preventScroll: true });
    }
    this.render();
  };

  Kit.prototype.next = function () {
    var self = this;
    if (this.step < STEPS) {
      var miss = this.stepMissing(this.step);
      if (miss.length) {
        miss.forEach(function (m) { self.showErr(m.key, true); });
        this.toast('Te falta: ' + miss.map(function (m) { return m.label; }).join(', '));
        var first = this.$('[data-err="' + miss[0].key + '"]');
        if (first) first.closest('.sk-group, .sk-slot, .sk-panel').scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      this.showStep(this.step + 1, true);
      return;
    }
    var all = this.missing();
    if (all.length) {
      all.forEach(function (m) { self.showErr(m.key, true); });
      this.showStep(all[0].step, true);
      this.toast('Te falta: ' + all.map(function (m) { return m.label; }).join(', '));
      return;
    }
    this.addToCart();
  };
})();